/*
 * @Author: your name
 * @Date: 2020-06-24 15:00:44
 * @LastEditTime: 2020-07-09 16:05:31
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Parts_APP\src\main.js
 */
import 'vant/lib/index.css'
import 'element-ui/lib/theme-chalk/index.css'
import('./assets/css/base.css')

import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import 'lib-flexible'
import '@/permission' // permission control
import { checkNumberFloat } from './utils'

// 基础样式 引入
// 阻止启动生产消息
Vue.config.productionTip = false
import uuid from 'uuid/v4'
window.uuid = uuid
// vant UI
import Vant from 'vant'
import ElementUI from 'element-ui'
import jwtDecode from 'jwt-decode'
import { Lazyload } from 'vant';
Vue.use(Lazyload);
Vue.prototype.jwtDecode = jwtDecode
Vue.use('Vant')
Vue.use(ElementUI)
// 列表 奇偶 颜色变
Vue.prototype.tableRowClassName = function({ row, rowIndex }) {
    if (rowIndex % 2 === 0) {
        return 'warning-row'
    } else if (rowIndex % 2 === 1) {
        return 'success-row'
    }
    return ''
}
Vue.use(Vant)
Vue.prototype.checkNumberFloat = checkNumberFloat

const moment = require('moment')
Vue.prototype.moment = moment
/** 权限指令**/
Vue.directive('has', {
    bind: function(el, binding) {
        if (!Vue.prototype.$_has(binding.value)) {
            el.style.display = 'none'
        }
    }
})
// 权限检查方法
Vue.prototype.$_has = function(value) {
    const all_permission = '*:*:*'
    const permissions = store.state.user && store.state.user.permissions
    const permissionsBlacklist = store.state.user.permissionsBlacklist
    if (value) {
        // todo: permissions是结构数组， 是否有权限需要进一步分析
        const result = permissions.some((permission) => {
        if (permission.permission === all_permission) {
            if (permissionsBlacklist && permissionsBlacklist.indexOf(value) > -1) {
            return false
            }
            return true
        }
        return permission.permission == value
        })
        return !!result
    } else {
        return false
    }
    // return store.state.user.permissions.indexOf(value) >= 0
}
// const hasPermissions = (value) => {
//     const all_permission = '*:*:*'
//     const permissions = store.getters && store.getters.permissions
//     const permissionsBlacklist = store.state.user.permissionsBlacklist
  
//     if (value) {
//       // todo: permissions是结构数组， 是否有权限需要进一步分析
//       const result = permissions.some((permission) => {
//         if (permission.permission === all_permission) {
//           if (permissionsBlacklist && permissionsBlacklist.indexOf(value) > -1) {
//             return false
//           }
//           return true
//         }
//         return permission.permission == value
//       })
//       return !!result
//     } else {
//       return false
//     }
//   }
// 移动端调试工具 log日志 网络请求  dom
// import Vconsole from 'vconsole'
// new Vconsole()
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
